import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-619fc91f")

_pushScopeId("data-v-619fc91f")
const _hoisted_1 = { class: "flex align-center" }
const _hoisted_2 = {
  key: 0,
  class: "flex-center margin-right-10"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("只看已选")
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("完成")
const _hoisted_6 = {
  key: 0,
  class: "selected"
}
const _hoisted_7 = {
  key: 1,
  class: "list"
}
const _hoisted_8 = { class: "selected" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_search_input = _resolveComponent("search-input")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_color_picker = _resolveComponent("el-color-picker")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_image = _resolveComponent("el-image")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      (!_ctx.showSelectedOnly)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode(_component_search_input, {
              modelValue: _ctx.keyword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.keyword = $event)),
              class: "search-input",
              onSearch: _ctx.handleSearch
            }, null, 8, ["modelValue", "onSearch"]),
            _createVNode(_component_el_select, {
              onChange: _ctx.handleSearchParam,
              class: "selector",
              modelValue: _ctx.orientation,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.orientation = $event)),
              placeholder: "方向"
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orientations, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["onChange", "modelValue"]),
            _createVNode(_component_el_select, {
              onChange: _ctx.handleSearchParam,
              class: "selector",
              modelValue: _ctx.size,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.size = $event)),
              placeholder: "方向"
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sizes, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["onChange", "modelValue"]),
            _createVNode(_component_el_color_picker, {
              onChange: _ctx.handleSearchParam,
              modelValue: _ctx.color,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.color = $event)),
              predefine: _ctx.predefineColors.map(p => '#' + p.value)
            }, null, 8, ["onChange", "modelValue", "predefine"])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.singleMode)
        ? (_openBlock(), _createBlock(_component_el_checkbox, {
            key: 1,
            modelValue: _ctx.showSelectedOnly,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.showSelectedOnly = $event))
          }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _hoisted_4,
      (!_ctx.singleMode)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 2,
            type: "primary",
            onClick: _ctx.submit
          }, {
            default: _withId(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.showSelectedOnly)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "flex infinite-list-wrapper list",
          onScroll: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
          ref: "scrollContainer"
        }, [
          (_openBlock(), _createBlock(_Fragment, null, _renderList(3, (column) => {
            return _createVNode("div", {
              class: "flex-1",
              key: column,
              span: "8"
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.images.filter(i => i.number % 3 === column - 1), (image) => {
                return (_openBlock(), _createBlock("div", {
                  key: image.photoModalMediumId,
                  class: "list-item"
                }, [
                  _createVNode(_component_el_image, {
                    onClick: ($event: any) => (_ctx.selectImage(image)),
                    src: image.photoModalImageGridItemSrc
                  }, null, 8, ["onClick", "src"]),
                  (_ctx.isSelected(image))
                    ? (_openBlock(), _createBlock("div", _hoisted_6, [
                        _createVNode(_component_el_button, {
                          type: "success",
                          circle: "",
                          icon: "el-icon-check"
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          }), 64))
        ], 544))
      : _createCommentVNode("", true),
    (_ctx.showSelectedOnly)
      ? (_openBlock(), _createBlock("ul", _hoisted_7, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedImages, (image) => {
            return (_openBlock(), _createBlock("li", {
              key: image.photoModalMediumId,
              class: "list-item"
            }, [
              _createVNode(_component_el_image, {
                src: image.photoModalImageGridItemSrc
              }, null, 8, ["src"]),
              _createVNode("div", _hoisted_8, [
                _createVNode(_component_el_button, {
                  type: "danger",
                  circle: "",
                  icon: "el-icon-delete",
                  onClick: ($event: any) => (_ctx.removeImage(image))
                }, null, 8, ["onClick"])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
})